<template>
  <div class="teampage">
    <div class="desc_part">
      <h3>Our Team</h3>
      <div class="desc" v-if="page_data != null" v-html="page_data.post_content">
      </div>
    </div>
    <div class="slide-arrows">
      <button class="slide-left"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path></svg></button>
      <button class="slide-right"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" class="svg-inline--fa fa-arrow-right fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path></svg></button>
    </div>
    <div class="slideshow_container">
      <div class="slideshow_part">
        <div v-bind:key="slide.id" v-for="slide in slider_images" class="slide_item">
          <input type="hidden" class="member_id" :value="slide.id" />
          <div class="image_part">
            <img :src="slide.url" class="slide_image noncolored" />
            <img :src="slide.colored" class="slide_image colored" />
          </div>
          <div class="slide_desc">
            <div class="name desktop">
              <h3>{{slide.name}}</h3>
            </div>
            <div class="name mobile">
              <h3><router-link :to="slide.link">{{slide.name}}</router-link></h3>
            </div>
            <h4>{{slide.role}}</h4>
          </div>
        </div>
      </div>
      <div class="individual_part">
        <div class="slide_item" style="display:none">
          <div class="image_part">
            <img class="slide_image colored" />
          </div>
          <div class="ind_menu">
            <ul>
              <!-- <li class="blog-link"><a href="#" target="_blank">Blog</a></li> -->
              <li class="email"><a href="#" target="_blank">Email</a></li>
              <li class="twitter"><a href="#" target="_blank">Twitter</a></li>
              <li class="linkedin"><a href="#" target="_blank">LinkedIn</a></li>
              <li class="ind_back">Back</li>
            </ul>
          </div>
        </div>
        <div class="individual_desc"><div class="individual_desc_content"></div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wpData: wpData,
      page_data: null,
      slider_images: null,
    };
  },
  mounted() {
    fetch(`${this.wpData.rest_url}/wp/v2/pagedata?page_title=Our Team`)
      .then(res => res.json())
      .then(data => {
        this.page_data = data;
        fetch(`${this.wpData.rest_url}/wp/v2/acfdata?post_id=${data.ID}&field_name=team_member`)
          .then(res => res.json())
          .then(data1 => {
            this.slider_images = [];
            data1.forEach((element, index) => {
              var obj = {id: index, has_post: element.has_post, url: element.member_black_white_image, colored: element.member_colored_image, name: element.member_full_name, role: element.member_position, user: element.member_user, email: element.member_email, linkedin: element.member_linkedin, twitter: element.member_twitter, description: element.member_description, link: '/team/'+index};
              this.slider_images.push(obj);
            });
            $(".slideshow_container").show();

            var that = this;
            $(document).ready(function() {
              // $(".slide_item .slide_desc .name.desktop").each(function(){
              //   if($(this).find('h3').height() > 48){
              //     for(var i = 1; i < $(this).find('h3').height()/48; i++){
              //       $(this).append("<div class='line' style='top: "+45*(i+1)+"px'></div>");
              //     }
              //   }
              // })
              var movedLeft;
              var movedLeftPos;
              var selected_member_index;
              $(".slide_item img.noncolored").each(function() {
                if ( $(this).height() < $(this).parent().height()) {
                  $(this).parent().width(($(this).parent().height() / $(this).height()) * 300);
                  $(this).height($(this).parent().height());
                  $(this).css("width", "auto");
                }
              });
              $(".slide_item .slide_desc .name").hover(
                function() {
                  $(this).parent().parent().find("img.noncolored").css("animation-name", "none");
                  $(this).parent().parent().find("img.noncolored").css("opacity", 1);
                  $(this).parent().parent().find("img.noncolored").fadeOut(500);
                  $(this).parent().parent().find("img.colored").fadeIn(500);
                },
                function() {
                  $(this).parent().parent().find("img.noncolored").fadeIn(500);
                  $(this).parent().parent().find("img.colored").fadeOut(500);
                }
              );
              $(".slide_item .image_part").hover(
                function() {
                  $(this).find("img.noncolored").css("animation-name", "none");
                  $(this).find("img.noncolored").css("opacity", 1);
                  $(this).find("img.noncolored").fadeOut(500);
                  $(this).find("img.colored").fadeIn(500);
                },
                function() {
                  $(this).find("img.noncolored").fadeIn(500);
                  $(this).find("img.colored").fadeOut(500);
                }
              );
              $(".slide_item .slide_desc .name").click(function() {
                $('.slide-arrows').fadeOut();
                selected_member_index = parseInt($(this).parent().parent().find(".member_id").val());
                $(".slideshow_part").addClass("ind_show");
                $(".individual_part").show();
                $(".individual_part .slide_item .image_part").width($(this).parent().parent().find(".image_part").width());
                $(".individual_part .slide_item img").attr( "src", that.slider_images[selected_member_index].colored);
                $(".individual_part .individual_desc .individual_desc_content").html(that.slider_images[selected_member_index].description);
                // if(that.slider_images[selected_member_index].has_post == false) {
                //   $(".individual_part .ind_menu .blog-link").hide();
                // }
                if(that.slider_images[selected_member_index].email == "")
                  $(".individual_part .ind_menu .email").hide();
                else {
                  let href = that.slider_images[selected_member_index].email.toLowerCase();
                  if (!href.startsWith('mailto:'))
                    href = 'mailto:' + href;
                  $(".individual_part .ind_menu .email a").attr('href', href);
                }
                if(that.slider_images[selected_member_index].twitter == "")
                  $(".individual_part .ind_menu .twitter").hide();
                else {
                  let href = that.slider_images[selected_member_index].twitter.toLowerCase();
                  $(".individual_part .ind_menu .twitter a").attr('href', href);
                }
                if(that.slider_images[selected_member_index].linkedin == "")
                  $(".individual_part .ind_menu .linkedin").hide();
                else {
                  let href = that.slider_images[selected_member_index].linkedin.toLowerCase();
                  $(".individual_part .ind_menu .linkedin a").attr('href', href);
                }
                $(".individual_part .slide_item").show();
                $(".individual_part .slide_item").css("left", $(this).parent().parent().position().left);
                $(".individual_part .slide_item").css("margin-left", 20 - $(this).parent().parent().position().left);
                $(".individual_part").addClass("show");
                var slideItem_pos = 20;
                var slideItem_posAfter = 0;
                var sliderWidth = 0;
                $(".slide_item").each(function() {
                  if ($(this).index(".slide_item") < selected_member_index) {
                    slideItem_pos += $(this).width();
                  }
                  if ($(this).index(".slide_item") >= selected_member_index) {
                    slideItem_posAfter += $(this).width();
                  }
                  sliderWidth += $(this).width();
                });
                if (slideItem_posAfter + 20 < $(".slideshow_part").width()) {
                  $(".slideshow_part").css("margin-left", 20 - slideItem_pos - $(".slideshow_part").width() + sliderWidth);
                  $(".slideshow_part .slide_item:first-child").css("margin-left", $(".slideshow_part").width() - sliderWidth);
                } else {
                  $(".slideshow_part .slide_item:first-child").css("margin-left", 20 - slideItem_pos + slider.scrollLeft);
                }
                $(".slideshow_part .image_part").css("opacity", "0");
                $(".slideshow_part .slide_item").each(function() {
                  var item_index = $(this).index(".slideshow_part .slide_item");
                  $(this).removeClass("show");
                  if (selected_member_index != item_index) {
                    $(this).addClass("hidden");
                  }
                });
                $(".individual_part .ind_menu li").each(function() {
                  var i = $(this).index(".individual_part .ind_menu li");
                  $(this).css("animation-delay", 1 + 0.1 * i + "s");
                });
                $(".individual_part .ind_menu").css(
                  "left",
                  $(".individual_part .image_part").width() + 80 + "px"
                );
                $(".individual_part .individual_desc").css(
                  "margin-left",
                  $(".individual_part .image_part").width() + 280 + "px"
                );
              });
              $(".individual_part .ind_menu .ind_back").click(function() {
                movedLeft = $(".slideshow_part .slide_item:first-child").css("margin-left");
                movedLeftPos = parseFloat(movedLeft.substring(0, movedLeft.length - 2)) - $(".slideshow_part").scrollLeft();
                $(".slideshow_part .member_id[value=" + selected_member_index + "]").next().animate({"opacity": "1"}, 500);
                $(".individual_part").fadeOut(500, function() {
                  $('.slide-arrows').fadeIn();
                  $(".individual_part").removeClass("show");
                  $(".individual_part .slide_item").css("margin-left", "");
                  $(".individual_part .slide_item").css("left", "");
                  $(".slideshow_part").removeClass("ind_show");
                  $(".slideshow_part").css("margin-left", "");
                  $(".slideshow_part .slide_item:first-child").css("margin-left", "");
                  $(".slideshow_part").scrollLeft(0 - movedLeftPos - 10);
                  // $(".slideshow_part .slide_item .line").removeClass("hovered");
                  $(".individual_part .ind_menu .blog-link").show();
                  $(".slideshow_part .slide_item").removeClass("hidden").addClass("show");
                });
              });

              $(".slide-left").on('click', function() {
                var left = $(".slideshow_part").scrollLeft();
                $(".slideshow_part").animate( { scrollLeft :left - 580 }, 500);
              });
              $(".slide-right").on('click', function() {
                var left = $(".slideshow_part").scrollLeft();
                $(".slideshow_part").animate( { scrollLeft :left + 580 }, 500);
              });
            });
          });
      });
      $(".slideshow_container").hide();
      const slider = document.querySelector(".slideshow_part");
      let isDown = false;
      let startX = 0;
      let scrollLeft = slider.scrollLeft;

      slider.addEventListener("mousedown", e => {
        isDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener("mouseleave", () => {
        isDown = false;
      });
      slider.addEventListener("mouseup", () => {
        isDown = false;
      });
      slider.addEventListener("mousemove", e => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) / 2; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
      });

      slider.addEventListener("mousewheel", e => {
        if(!$(".slideshow_part").hasClass("ind_show")){
          e.preventDefault();
          const x = e.wheelDelta / 20;
          slider.scrollLeft = slider.scrollLeft - x;
        }
      });
  }
};
</script>

<style>
.teampage {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 100px);
  padding-top: 50px;
  background: #fff;
  color: #172c62;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.desc_part {
  width: 700px;
  margin-left: 200px;
  text-align: left;
}
.desc_part h3 {
  font-size: 45px;
  animation-name: moveup;
  animation-duration: 0.7s;
}
.desc_part .desc p {
  font-size: 22px;
  opacity: 0;
  margin-bottom: 0;
  animation-duration: 0.5s;
  animation-name: moveup;
  animation-fill-mode: forwards;
}

.slideshow_part {
  position: absolute;
  width: 100%;
  padding-right: 20px;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  will-change: transform;
  user-select: none;
  cursor: pointer;
  z-index: 900;
  transition: margin-left 1s ease-in-out;
}

.slide_item {
  display: inline-block;
  height: 465px;
  margin: 10px 0;
  vertical-align: top;
  text-align: left;
  transition: margin-left 1s ease-in-out;
}

.slide_item.show {
  transition: none;
}

.slide_item.hidden .image_part,
.slide_item.hidden .slide_desc {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  transition-delay: 0.5s;
}

.slide_item.show .image_part,
.slide_item.show .slide_desc {
  opacity: 1 !important;
  transition: opacity 0.5s ease-in-out;
}

.slide_item:first-child img.noncolored {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}

.slide_item:first-child h3 {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
}

.slide_item:first-child h4 {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 0.7s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(2) img.noncolored {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 1s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(2) h3 {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 1.2s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(2) h4 {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 1.4s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(3) img.noncolored {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 1.7s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(3) h3 {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 1.9s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(3) h4 {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 2.1s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(4) img.noncolored {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 2.4s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(4) h3 {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 2.6s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(4) h4 {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 2.8s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(5) img.noncolored {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 3.1s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(5) h3 {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 3.3s;
  animation-fill-mode: forwards;
}

.slide_item:nth-child(5) h4 {
  opacity: 0;
  animation-duration: 0.5s;
  animation-name: moveleft;
  animation-delay: 3.5s;
  animation-fill-mode: forwards;
}

.slide_item .image_part {
  min-width: 300px;
  height: 100%;
  position: relative;
  display: inherit;
}

.individual_part.show .slide_item .image_part {
  position: absolute;
  top: 0;
  animation: none;
}

.slide_item .image_part img {
  position: absolute;
  left: 0;
  width: 100%;
}

.slideshow_part .slide_item .image_part img.colored {
  display: none;
}

.slide_item h3 {
  font-size: 37px;
  display: inline;
  overflow-wrap: break-word;
  white-space: normal;
  background-image: linear-gradient(180deg,transparent 20%,currentColor 21%);
  background-position: 0 40px;
  background-repeat: no-repeat;
  background-size: 0 6px;
  transition: background-size .5s ease-in-out .3s;
}

.slide_item .name {
  position: relative;
  max-width: 210px;
}

.slide_item .name.mobile{
  display: none;
}

.slide_item .name h3 a{
  color: #172c62;
}

.slide_item .name h3:hover {
  background-size: 100% 6px;
  transition-delay: 0s;
}

/*.slide_item .name .line {
  width: 0;
  height: 1.5px;
  position: absolute;
  transition: width 0.2s ease-in-out;
  top: 45px;
  left: 50%;
  transform: translateX(-50%);
  background: #172c62;
}

.slide_item .name .line.hovered {
  width: 100%;
}

.slide_item .name:hover .line {
  width: 100%;
}*/

.slide_item h4 {
  font-size: 20px;
  padding: 0;
}

.slide_desc {
  display: inline-block;
  vertical-align: top;
  margin-top: -20px;
  margin-left: -20px;
}

.slideshow_container {
  overflow: hidden;
  position: relative;
  height: 460px;
}

.individual_part .slide_item {
  position: absolute;
}

.individual_part {
  z-index: -1;
}

.individual_part .ind_menu {
  position: absolute;
  left: 400px;
  top: 30%;
}

.individual_part.show {
  z-index: 1000;
}

.memberhidden{
  opacity: 0;
}

.individual_part.show .ind_menu {
  z-index: 1000;
}

.individual_part.show .ind_menu li {
  animation-duration: 1s;
  animation-name: moveup;
  animation-fill-mode: forwards;
}

.individual_part.show .ind_menu li a {
  text-decoration: none;
  color: #172c62;
}

.individual_part.show .ind_menu li.ind_back {
  animation-name: moveup1;
  padding: 0 10px;
  text-align: center;
  border: 1px solid #172c62;
  transition: all 0.2s ease-in-out;
}

.individual_part.show .ind_menu li.ind_back:hover{
  background: #172c62;
  color: #fff;
}

.individual_part.show .individual_desc {
  position: absolute;
  top: 0;
  z-index: 1000;
  overflow: hidden;
}

.individual_part.show .individual_desc .individual_desc_content{
  width: 615px;
  height: 450px;
  overflow-y: scroll;
}

.individual_part.show .individual_desc p {
  animation-duration: 1s;
  animation-name: moveup;
  animation-delay: 2s;
  animation-fill-mode: forwards;
}

.individual_part .ind_menu ul {
  display: flex;
  flex-direction: column;
}

.individual_part .ind_menu li {
  text-align: right;
  opacity: 0;
  color: #172c62;
  font-size: 22px;
  text-align: right;
  cursor: pointer;
}

.individual_part .ind_menu .ind_back {
  margin-top: 50px;
}

.individual_desc {
  width: 600px;
  margin-left: 600px;
  text-align: left;
}

.individual_desc p {
  margin-bottom: 2rem;
  font-size: 17px;
  line-height: 21px;
  opacity: 0;
}

@keyframes moveup {
  from {
    margin-top: 100px;
    opacity: 0;
  }

  to {
    margin-top: 0;
    opacity: 1;
  }
}

@keyframes moveup1 {
  from {
    margin-top: 120px;
    opacity: 0;
  }

  to {
    margin-top: 50px;
    opacity: 1;
  }
}

@keyframes moveleft {
  from {
    margin-left: 100px;
    opacity: 0;
  }

  to {
    margin-left: 0;
    opacity: 1;
  }
}
.slide-arrows {
  text-align: left;
  margin: 0 10vw 15px;
}
.slide-arrows button {
  width: 50px;
  height: 50px;
  font-size: 24px;
  padding: 0;
  border-radius: 50%;
  margin: 0 15px;
  border: 2px solid #172c62;
  color: #172c62;
  background: transparent;
  outline: none;
}
.slide-arrows button:hover,
.slide-arrows button:focus {
  background: #172c62;
  color: white;
}
@media screen and (max-width: 900px){
  .desc_part{
    width: 90%;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 30px;
  }
  .slideshow_container {
    height: 300px;
  }
  .slide_item{
    height: 300px;
  }
  .slide_item .name.mobile{
    display: block;
  }
  .slide_item .name.desktop{
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AppTeamPage.vue